import router from "./router";
import store from "./store";
import storage from "store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar custom style
// import findLast from "lodash/findLast";
import { notification } from "ant-design-vue";
import { USER_TOKEN } from "@/store/mutation-types";

NProgress.configure({ showSpinner: false }); // NProgress Configuration
const whiteList = ["login", "foreign"]; // 白名单
const loginRoutePath = "/user/login"; //登录路由
const defaultRoutePath = "/system/user-list"; //默认路由

// router开始工作
router.beforeEach((to, from, next) => {
  NProgress.start(); //开始 progress bar
  if (storage.get(USER_TOKEN)) {
    // store.dispatch("Logout"); // 测试环境使用，需注释
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath });
      NProgress.done();
    } else {
      if (store.getters.addRouters.length === 0) {
        // 生成动态路由
        store
          .dispatch("GenerateRoutes")
          .then(() => {
            // 动态添加可访问路由表
            router.addRoutes(store.getters.addRouters);
            // 请求带有redirect重定向时，登录自动重定向到该地址
            const redirect = decodeURIComponent(from.query.redirect || to.path);
            if (to.path == redirect) {
              // 设置replace:true，这样导航就不会留下历史记录
              next({ ...to, replace: true });
            } else {
              next({ path: redirect });
            }
          })
          .catch(() => {
            notification.error({
              message: "错误",
              description: "生成动态路由失败，请重试"
            });
            //失败时，调用登出，来清空历史保留信息
            store.dispatch("Logout").then(() => {
              next({
                path: loginRoutePath,
                query: { redirect: to.fullPath }
              });
            });
          });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      next();
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } });
      NProgress.done(); // 如果当前页面是登录后不会触发每个钩子，所以手动处理它
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
